// extracted by mini-css-extract-plugin
export var container = "_e0-0";
export var icon = "_e0-1";
export var text = "_e0-2";